<template>
  <div>
    <div class="banner_about">
      <div class="nav-top">
        <div class="w">
          <HeadNav activeIndex="5" textColor="#fff" color="#fff"></HeadNav>
        </div>
      </div>
    </div>
    <div class="w" style="margin-top: 90px">
      <el-row :gutter="20">
        <el-col :span="8" class="flex justify-content align-items">
          <div class="grid-content flex column justify-content align-items">
            <img src="../assets/icon_office.png" alt="" />
            <p class="title_about">全国多个办事处</p>
            <p class="content_about">
              通过全国驻各地的办事处提供及时上门服务为用户提供免费培训
            </p>
          </div>
        </el-col>
        <el-col :span="8" class="flex justify-content align-items">
          <div class="grid-content flex column justify-content align-items">
            <img src="../assets/icon_repair.png" alt="" />
            <p class="title_about" style="color: #f35111">客户服务中心</p>
            <p class="content_about">
              客户服务中心提供5*8小时热线应答和在线技术支持服务
            </p>
          </div>
        </el-col>
        <el-col :span="8" class="flex justify-content align-items">
          <div class="grid-content flex column justify-content align-items">
            <img src="../assets/icon_service.png" alt="" />
            <p class="title_about" style="color: #f82929">专人应答服务</p>
            <p class="content_about">
              专人提供7*24小时手机应答服务并通过客服专刊及时反映行业动态
            </p>
          </div>
        </el-col>
      </el-row>

      <div class="about_title_big flex align-items justify-content">
        <img src="../assets/circular.png" alt="" />
        <p>公司简介</p>
        <img src="../assets/circular.png" alt="" class="rotateImg" />
      </div>
      <div class="introduce flex justify-content align-items">
        <div class="introduce_content flex align-items">
          <div class="box">
            <p class="box-title">北京东方艾学信息技术有限责任公司</p>
            <div class="box-content">
              AI Learning
                是一家通过ISO9001质量体系认证的国家高新技术企业，具有涉外调查资质；北京大数据协会副会长、副秘书长单位；中国商业统计学会常务理事单位、市场调查与教学研究分会常务理事副秘书长单位、数据科学与商业智能分会常务理事副秘书长单位；全国工业统计学教学研究会常务理事单位、青年统计学家协会创始常务理事单位、健康医疗大数据学会理事单位；中国现场统计研究会统计综合评价研究分会常务理事单位、经济与金融统计分会常务理事单位、大数据统计分会理事单位；中国市场信息调查业协会第三方评估委员会创始单位。
            </div>
            <!-- <div class="box-content">
              公司深耕市场调研、大数据与人工智能10余年，是以提供调研、数据资源、AI数据建模服务、教学科研平台为核心业务的行业大数据和人工智能平台及解决方案提供商。主要产品系列有：“东方神采”数据采集平台、“东方神灯”大数据分析挖掘平台、“东方神画”大数据可视化平台、“东方神评”专家评审平台、“东方神策”消费环境监测与评价系统、“AI实验室”、“AI云课堂”、AI学科竞赛云平台、“东方爱学”大数据资源平台、“AI学”大数据综合实践云平台、“AI研”大数据科研平台、“AI创新创业孵化平台”等。
            </div> -->
          </div>
        </div>
      </div>
      <div
        class="about_title_big flex align-items justify-content"
        style="margin-top: 20px"
      >
        <img src="../assets/circular.png" alt="" />
        <p>商业方案</p>
        <img src="../assets/circular.png" alt="" class="rotateImg" />
      </div>
      <div class="business flex">
        <div class="business_box">
          <img src="../assets/business_pic1.png" alt="" />
        </div>
        <div class="business_box flex column justify-content">
          <div style="margin-left: 40px">
            <div class="flex align-items">
              <img src="../assets/1.png" alt="" />
              <div class="text_box">
                <p>平台化操作</p>
                <span>PLATFORM OPERATION</span>
              </div>
            </div>
            <div class="business_box_content">
              公司以软件为核心，基于客户需求持续创新，<br />
              通过软件与专业教学科研的结合，<br />
              软件技术与服务的结合，提供应用，专业教学 科研系统个性化定制、<br />
              校企合作整体方案以及相关软件产品、平台及服务。
            </div>
          </div>
        </div>
      </div>
      <div class="business flex">
        <div class="business_box flex column justify-content">
          <div class="flex align-items">
            <img src="../assets/2.png" alt="" />
            <div class="text_box">
              <p>平台化操作</p>
              <span>PLATFORM OPERATION</span>
            </div>
          </div>
          <div class="business_box_content">
            公司以软件为核心，基于客户需求持续创新，<br />
            通过软件与专业教学科研的结合，<br />
            软件技术与服务的结合，提供应用，专业教学 科研系统个性化定制、<br />
            校企合作整体方案以及相关软件产品、平台及服务。
          </div>
        </div>

        <div class="business_box flex flex-end">
          <img src="../assets/business_pic2.png" alt="" />
        </div>
      </div>
    </div>
    <!--<div class="about_banner3">
      <div class="banner_box3">

      </div>
    </div>-->
    <div class="w">
      <div class="about_title_big flex align-items justify-content">
        <img src="../assets/circular.png" alt="" />
        <p>公司优势</p>
        <img src="../assets/circular.png" alt="" class="rotateImg" />
      </div>
      <div class="card1">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="flex column align-items justify-content">
              <div class="slide">
                <img src="../assets/zy_icon.png" alt="" />
              </div>
              <div style="font-size: 26px; margin-top: 20px">专业</div>
              <div style="font-size: 20px; margin-top: 10px">
                专业的调查服务、研究报告
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex column align-items justify-content">
              <div class="slide">
                <img src="../assets/cb_icon.png" alt="" />
              </div>
              <div style="font-size: 26px; margin-top: 20px">低成本</div>
              <div
                style="
                  font-size: 20px;
                  margin-top: 10px;
                  text-align: center;
                  width: 70%;
                "
              >
                提供不同场景的专业调查 模板、题库减少设计问卷成本
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex column align-items justify-content">
              <div class="slide">
                <img src="../assets/xl_icon.png" alt="" />
              </div>
              <div style="font-size: 26px; margin-top: 20px">高效率</div>
              <div
                style="
                  font-size: 20px;
                  margin-top: 10px;
                  text-align: center;
                  width: 70%;
                "
              >
                多终端多场景链接用户 多种质控手段保证数据真实有效
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <HeadFooter></HeadFooter>
  </div>
</template>

<script>
import HeadNav from "@/components/HeadNav";
import HeadFooter from "@/components/HeadFooter";

export default {
  name: "About",
  components: {
    HeadNav,
    HeadFooter,
  },
};
</script>
<style scoped>
.introduce {
  width: 100%;
  height: 660px;
  background: url("../assets/banner_introduce.png") no-repeat top;
  margin-top: 60px;
}
</style>
<style>
.slide:hover {
  margin-top: -5px;
}
.card1 {
  margin-top: 60px;
}
.banner_box3 {
  width: 600px;
  height: 470px;
  background: red;
  position: absolute;
  top: 188px;
  left: 351px;
}
.about_banner3 {
  padding-top: 1px;
  width: 100%;
  height: 800px;
  background: url("../assets/about_banner3.jpg") no-repeat center;
  margin-top: 180px;
  position: relative;
  background-size: 100% 100%;
}
.business_box_content {
  font-size: 16px;
  color: #333;
  margin-top: 50px;
  line-height: 26px;
}
.text_box {
  margin-left: 10px;
}
.text_box p {
  font-size: 24px;
  color: #0080ff;
  margin-bottom: 5px;
}
.text_box span {
  font-size: 16px;
  color: #666;
}
.business {
  margin-top: 100px;
}
.business_box {
  flex: 1;
  height: 360px;
}
.box-content {
  font-size: 16px;
  color: #333;
  margin-top: 25px;
  line-height: 26px;
  text-indent: 2em;
}
.box-title {
  font-size: 22px;
  color: #010101;
}
.introduce_content {
  height: 286px;
  width: 886px;
  background: url("../assets/textbox.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 265px;
}
.box {
  width: 78%;
  height: 80%;
  margin-left: 50px;
}

.about_title_big {
  margin-top: 90px;
}
.about_title_big p {
  font-size: 30px;
  color: #333;
  margin: 0 20px;
}
.rotateImg {
  transform: rotate(60deg);
  -webkit-transform: rotate(60deg); /*兼容-webkit-引擎浏览器*/
  -moz-transform: rotate(60deg);
}
.banner_about {
  height: 600px;
  width: 100%;
  position: relative;
  background: url("../assets/banner_about.png") no-repeat center;
}
.nav-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}
.title_about {
  font-size: 18px;
  color: #0080ff;
  margin-top: 26px;
}
.content_about {
  font-size: 14px;
  color: #333;
  margin-top: 22px;
  text-align: center;
  line-height: 26px;
}
.grid-content {
  width: 75%;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px solid transparent;
  color: #333;
  position: relative;
}
</style>